// PDFs and external links open in a new tab. Any host containing "uoguelph"
// (U of G sites, BBIS, Qualtrics) or "aadchug" (Drupal on Pantheon) stays in the same tab.
function opensInNewTab(url) {
  let parsed
  try {
    parsed = new URL(url, "https://alumni.uoguelph.ca")
  } catch {
    return false
  }
  if (!parsed.protocol.startsWith("http")) return false // mailto:, tel:, etc.
  if (parsed.pathname.toLowerCase().endsWith(".pdf")) return true
  return !/uoguelph|aadchug/i.test(parsed.hostname)
}

function applyLinkTarget(anchor) {
  if (!opensInNewTab(anchor.getAttribute("href"))) return
  anchor.target = "_blank"
  anchor.relList.add("noopener", "noreferrer")
}

function applyLinkTargets(root) {
  if (root.matches?.("a[href]")) applyLinkTarget(root)
  root.querySelectorAll?.("a[href]").forEach(applyLinkTarget)
}

export { opensInNewTab, applyLinkTargets }
